export default __webpack_public_path__ + "static/abacavideo-2497adc471e568454e69d91ebad1d185.mp4";